import { render, staticRenderFns } from "./Voorhoeder.vue?vue&type=template&id=78be4cda&"
import script from "./Voorhoeder.vue?vue&type=script&lang=js&"
export * from "./Voorhoeder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports